import { ViewConfig } from "datasheets/model/core/Workbook";
import { Component } from "./Component";

export const viewType = "form";

export interface FormViewConfig extends ViewConfig {
  components: { [key: string]: Component };
}
